<template>
  <div class="sales-index">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售工作台</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="商户类型:">
        <el-select
          size="small"
          v-model="formInline.agentType"
          placeholder="全部"
        >
          <el-option
            v-for="(val, index) in merchantTypeList"
            :label="val.label"
            :value="val.value"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商户:">
        <el-select
          size="small"
          v-model="formInline.merchantName"
          filterable
          allow-create
          default-first-option
          placeholder="请选择或输入商户名称"
          @blur="selectMerchantNameBlur"
        >
          <el-option
            v-for="(val, index) in merchantList"
            :label="val"
            :value="val"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务商:">
        <el-select
          size="small"
          v-model="formInline.disCompanyName"
          filterable
          allow-create
          default-first-option
          placeholder="请选择或输入服务商名称"
          @blur="selectDisCompanyBlur"
        >
          <el-option
            v-for="(val, index) in disCompanyList"
            :label="val.label"
            :value="val.label"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间范围: ">
        <el-date-picker
          size="small"
          v-model="formInline.date"
          type="daterange"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" icon="el-icon-refresh-left" @click="reset">清空</el-button>
      </el-form-item>
    </el-form>

    <!-- 快捷入口 -->
    <div class="quick-entries">
      <span class="quick-entries-label">快捷入口：</span>
      <el-button type="text" icon="el-icon-s-data" @click="jumpToPage('/sales/salesBatchStatistics')">批次统计</el-button>
      <el-button type="text" icon="el-icon-s-marketing" @click="jumpToPage('/sales/salesMerchantStatistics')">商户统计</el-button>
      <el-button type="text" icon="el-icon-s-marketing" @click="jumpToPage('/sales/allCustomersMonthlyFlow')">月度流水</el-button>
      <el-button type="text" icon="el-icon-s-custom" @click="jumpToPage('/sales/merchantList')">商户列表</el-button>
    </div>

    <div class="dashboard-container">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="card-wrapper">
            <el-card class="box-card stat-card stat-card--merchant" shadow="hover">
              <div slot="header" class="clearfix header-title">
                <i class="el-icon-s-custom header-icon"></i>
                <span>客户数量</span>
              </div>
              <div class="merchants">
                <div class="stat-value-wrap" v-loading="loading">
                  <span class="count">{{ partnerMerchantNum }}</span>
                </div>
                <p class="stat-label"><span>合作商户数</span></p>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="card-wrapper">
            <el-card class="box-card stat-card stat-card--recharge" shadow="hover">
              <div slot="header" class="clearfix header-title">
                <i class="el-icon-coin header-icon"></i>
                <span>流水（元）</span>
              </div>
              <div class="total-disbursement">
                <div class="stat-value-wrap" v-loading="loading">
                  <span class="amount">{{ formatAmount(totalPreTaxAmount) }}</span>
                </div>
                <p class="stat-label"><span>税前金额</span></p>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="card-wrapper">
            <el-card class="box-card stat-card stat-card--disburse gross-card-clickable" shadow="hover" @click.native="openGrossDialog">
              <div slot="header" class="clearfix header-title">
                <i class="el-icon-money header-icon"></i>
                <span>毛利（元）</span>
                <span class="gross-card-hint"><i class="el-icon-data-line"></i> 点击查看月度趋势</span>
              </div>

              <div class="total-disbursement">
                <div class="stat-value-wrap" v-loading="loading">
                  <span class="amount">{{ formatAmount(totalGrossProfit) }}</span>
                </div>
                <p class="stat-label"><span>总毛利</span></p>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 月度毛利折线图弹窗(点总毛利卡片打开, REQ-015 F002/T-041, 交互沿用批次统计页折线图设计) -->
    <el-dialog
      title="月度毛利趋势"
      :visible.sync="grossDialogVisible"
      width="860px"
      class="gross-chart-dialog"
      @open="onGrossDialogOpen"
      @closed="onGrossDialogClosed"
    >
      <div class="gross-dialog-toolbar">
        <el-form :inline="true" size="small">
          <el-form-item label="月份范围:">
            <el-date-picker
              v-model="grossStartMonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="开始月份"
              style="width: 120px"
            />
            <span class="range-sep">至</span>
            <el-date-picker
              v-model="grossEndMonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="结束月份"
              style="width: 120px"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="fetchMonthlyGrossChart">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-loading="grossChartLoading" class="gross-chart-body">
        <div ref="grossChartRef" class="gross-chart-wrap"></div>
        <div v-if="!grossChartLoading && !grossHasData" class="chart-empty">
          <i class="el-icon-document"></i>
          <p>暂无数据</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  getSalesStatisticsData,
  getSalesMerchantName,
  getDisCompanyNames,
  getSalesMonthlyGrossProfit,
} from "../../api/userMG";
export default {
  name: "index-sales",
  components: {
    // "notice-list": noticeList,
  },

  data() {
    return {
      loading: false,
      partnerMerchantNum: 0,
      totalPreTaxAmount: "0.00",
      totalGrossProfit: "0.00",
      merchantList: [],
      disCompanyList: [],
      merchantTypeList: [
        {
          label: "普通商户",
          value: 1,
        },
        {
          label: "代理商户",
          value: 2,
        },
      ],
      // 月度毛利折线图弹窗(REQ-015 F002/T-041)
      grossDialogVisible: false,
      grossStartMonth: (() => {
        const n = new Date();
        return `${n.getFullYear()}-01`;
      })(),
      grossEndMonth: (() => {
        const n = new Date();
        return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}`;
      })(),
      monthlyGrossData: [],
      grossChart: null,
      grossChartLoading: false,
      formInline: {
        disCompanyName: "",
        merchantName: "",
        startDate: "",
        endDate: "",
        agentType: "",
        date: [],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },

  computed: {
    grossHasData() {
      return this.monthlyGrossData && this.monthlyGrossData.length > 0;
    },
  },

  created() {
    getSalesMerchantName({
      page: 1,
      pageSize: 9999,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.merchantList = res.data.items;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});

    // 服务商
    getDisCompanyNames({
      page: 1,
      pageSize: 9999,
      type: 2,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.disCompanyList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});
  },

  mounted() {
    // 处理日期范围
    if (this.formInline.date && this.formInline.date.length === 2) {
      this.formInline.startDate = this.formInline.date[0] || "";
      this.formInline.endDate = this.formInline.date[1] || "";
    } else {
      this.formInline.startDate = "";
      this.formInline.endDate = "";
    }
    this.getdata(this.formInline);
  },

  watch: {
    "formInline.agentType": function (newVal) {
      let params = {
        agentType: newVal,
        page: 1,
        pageSize: 9999,
      };

      getSalesMerchantName(params)
        .then((res) => {
          if (res.msg == "success") {
            this.merchantList = res.data.items;
            this.formInline.merchantName = "";
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
  },

  methods: {
    // 金额千分位格式化，保留两位小数
    formatAmount(val) {
      if (val === null || val === undefined || val === "") return "0.00";
      const num = Number(val);
      if (isNaN(num)) return String(val);
      return num.toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    jumpToPage(path) {
      this.$router.push({ path });
    },

    getdata(formInline) {
      this.loading = true;
      const params = {
        merchantName: formInline.merchantName,
        disCompanyName: formInline.disCompanyName,
        startDate: formInline.startDate,
        endDate: formInline.endDate,
        agentType: formInline.agentType,
      };
      getSalesStatisticsData(params)
        .then((res) => {
          if (res.msg == "success") {
            this.partnerMerchantNum = res.data.partnerMerchantNum;
            this.totalPreTaxAmount = res.data.totalPreTaxAmount;
            this.totalGrossProfit = res.data.totalGrossProfit;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    search() {
      if (this.formInline.date && this.formInline.date.length === 2) {
        this.formInline.startDate = this.formInline.date[0] || "";
        this.formInline.endDate = this.formInline.date[1] || "";
      } else {
        this.formInline.startDate = "";
        this.formInline.endDate = "";
      }
      this.getdata(this.formInline);
    },

    reset() {
      this.formInline = {
        disCompanyName: "",
        merchantName: "",
        startDate: "",
        endDate: "",
        agentType: "",
        date: [],
      };
      this.getdata(this.formInline);
    },
    selectMerchantNameBlur(e) {
      this.formInline.merchantName = e.target.value;
    },
    selectDisCompanyBlur(e) {
      this.formInline.disCompanyName = e.target.value;
    },
    // ===== 月度毛利折线图弹窗(REQ-015 F002/T-041, 交互沿用批次统计页折线图设计) =====
    openGrossDialog() {
      this.grossDialogVisible = true;
    },
    onGrossDialogOpen() {
      window.addEventListener("resize", this.handleGrossChartResize);
      this.$nextTick(() => {
        this.initGrossChart();
        this.fetchMonthlyGrossChart();
      });
    },
    onGrossDialogClosed() {
      window.removeEventListener("resize", this.handleGrossChartResize);
      if (this.grossChart && this.grossChart.dispose) {
        this.grossChart.dispose();
      }
      this.grossChart = null;
    },
    initGrossChart() {
      if (this.grossChart && this.grossChart.dispose) {
        this.grossChart.dispose();
      }
      this.grossChart = null;
      const dom = this.$refs.grossChartRef;
      if (!dom) return;
      this.grossChart = echarts.init(dom);
    },
    // 构造月份区间列表（含首尾）
    getMonthRange(startMonth, endMonth) {
      const res = [];
      const [sy, sm] = startMonth.split("-").map(Number);
      const [ey, em] = endMonth.split("-").map(Number);
      let y = sy;
      let m = sm;
      while (y < ey || (y === ey && m <= em)) {
        res.push(`${y}-${String(m).padStart(2, "0")}`);
        m += 1;
        if (m > 12) {
          m = 1;
          y += 1;
        }
      }
      return res;
    },
    // 拉取并渲染月度毛利折线图(数据源: /v1/sales/monthly-gross-profit 改读 smc 快照)
    fetchMonthlyGrossChart() {
      const startMonth = this.grossStartMonth;
      const endMonth = this.grossEndMonth;
      if (!startMonth || !endMonth) {
        this.monthlyGrossData = [];
        this.renderGrossChart();
        return;
      }
      const [y1, m1] = startMonth.split("-").map(Number);
      const [y2, m2] = endMonth.split("-").map(Number);
      const monthDiff = (y2 - y1) * 12 + (m2 - m1);
      if (monthDiff < 0) {
        this.$message.warning("结束月份不能早于开始月份");
        return;
      }
      if (monthDiff > 23) {
        this.$message.warning("时间范围最大2年（24个月）");
        return;
      }
      this.grossChartLoading = true;
      getSalesMonthlyGrossProfit({ startDate: startMonth, endDate: endMonth })
        .then((res) => {
          if (res && (res.msg === "success" || res.code === 0) && res.data) {
            const items = Array.isArray(res.data) ? res.data : res.data.items || [];
            const map = {};
            items.forEach((d) => {
              const ym = (d.yearMonth || "").toString();
              if (!ym) return;
              const val = Number(d.grossProfit);
              map[ym] = (map[ym] || 0) + (isNaN(val) ? 0 : val);
            });
            // 空月补 0(AC-015-09)
            const fullMonths = this.getMonthRange(startMonth, endMonth);
            this.monthlyGrossData = fullMonths.map((ym) => ({
              yearMonth: ym,
              monthLabel: ym.replace("-", "年") + "月",
              totalGross: map[ym] || 0,
            }));
            this.renderGrossChart();
          } else {
            this.monthlyGrossData = [];
            this.renderGrossChart();
            const msg = (res && (res.msg || res.message)) || "";
            if (msg) this.$message.error(msg);
          }
        })
        .catch((err) => {
          // 接口异常 → 弹窗空态提示(沿用原空态样式), 不报错崩页面
          this.monthlyGrossData = [];
          this.renderGrossChart();
          const data = err && err.response && err.response.data;
          const msg = (data && (data.msg || data.message)) || (err && err.message) || "";
          if (msg) this.$message.error(msg);
        })
        .finally(() => {
          this.grossChartLoading = false;
        });
    },
    renderGrossChart() {
      if (!this.grossChart) return;
      const aggregated = this.monthlyGrossData;
      const months = aggregated.map((d) => d.yearMonth);
      const monthLabels = aggregated.map((d) => d.monthLabel);
      const values = aggregated.map((d) => (d.totalGross != null ? Number(d.totalGross) : 0));
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "line" },
          formatter: (params) => {
            if (!params || !params.length) return "";
            const idx = params[0].dataIndex;
            const ym = months[idx] || "";
            const val = aggregated[idx] ? aggregated[idx].totalGross : 0;
            return `${ym}<br/>当月总毛利：${Number(val).toFixed(2)} 元`;
          },
        },
        grid: { left: 56, right: 32, bottom: 36, top: 36, containLabel: true },
        xAxis: {
          type: "category",
          data: monthLabels.length ? monthLabels : ["暂无数据"],
          axisLine: { lineStyle: { color: "#e4e7ed" } },
          axisLabel: { color: "#606266", fontSize: 12 },
        },
        yAxis: {
          type: "value",
          name: "毛利(元)",
          nameTextStyle: { color: "#606266", fontSize: 12 },
          axisLine: { show: false },
          splitLine: { lineStyle: { color: "#f0f0f0", type: "dashed" } },
          axisLabel: { color: "#606266", fontSize: 12 },
        },
        series: [
          {
            name: "月度毛利",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 6,
            data: values.length ? values : [0],
            itemStyle: { color: "#67C23A" },
            lineStyle: { width: 2 },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "rgba(103, 194, 58, 0.25)" },
                  { offset: 1, color: "rgba(103, 194, 58, 0.02)" },
                ],
              },
            },
          },
        ],
      };
      this.grossChart.setOption(option, true);
      this.$nextTick(() => this.grossChart && this.grossChart.resize());
    },
    handleGrossChartResize() {
      this.grossChart && this.grossChart.resize();
    },
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleGrossChartResize);
    if (this.grossChart && this.grossChart.dispose) {
      this.grossChart.dispose();
    }
    this.grossChart = null;
  },

  destroyed() {},
};
</script>

<style scoped>
.sales-index {
  padding-bottom: 24px;
}

.user-search {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.el-form-item {
  margin-bottom: 16px !important;
}

.quick-entries {
  margin-bottom: 20px;
  padding: 12px 16px;
  background: #f4f4f5;
  border-radius: 4px;
  font-size: 13px;
}

.quick-entries-label {
  color: #606266;
  margin-right: 8px;
}

.quick-entries .el-button--text {
  margin-right: 16px;
  padding: 0 4px;
}

.dashboard-container {
  min-height: 200px;
}

.stat-value-wrap {
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-card {
  min-height: 160px;
  text-align: center;
  border-radius: 6px;
}

.box-card >>> .el-card__header {
  padding: 14px 20px;
  font-size: 15px;
}

.box-card >>> .el-card__body {
  padding: 20px;
}

.clearfix::after {
  content: "";
  display: block;
  clear: both;
}

.header-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.header-title span {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.header-icon {
  font-size: 20px;
  color: #909399;
}

.stat-card--merchant .header-icon {
  color: #409eff;
}

.stat-card--recharge .header-icon {
  color: #67c23a;
}

.stat-card--disburse .header-icon {
  color: #e6a23c;
}

.card-wrapper {
  margin-top: 20px;
}

.task-status,
.service-fees {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.task-status .status-item,
.service-fees .fee-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 20px;
}

.task-status .total-tasks {
  font-size: 26px;
  color: #409eff;
}

.task-status .incomplete-tasks {
  font-size: 26px;
  color: #f56c6c;
}

.task-status .pending-invoice {
  font-size: 26px;
  color: #e6a23c;
}

.task-status .completed-tasks {
  font-size: 26px;
  color: #67c23a;
}

.stat-label {
  margin: 8px 0 0;
  font-size: 13px;
  color: #909399;
}

.fee-item .zero-work-costs,
.fee-item .service-costs {
  font-size: 22px;
  font-weight: 500;
}

.fee-item .zero-work-costs {
  color: #606266;
}

.fee-item .service-costs {
  color: #909399;
}

.total-disbursement .amount,
.merchants .count {
  font-size: 28px;
  font-weight: 600;
}

.merchants .count {
  color: #409eff;
}

.total-disbursement .amount {
  color: #67c23a;
}

/* 总毛利卡片可点击暗示(REQ-015 F002: cursor/悬浮态) */
.gross-card-clickable {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.gross-card-clickable:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(103, 194, 58, 0.25);
}

.gross-card-hint {
  float: right;
  font-size: 12px;
  color: #909399;
  font-weight: normal;
}

/* 月度毛利折线图弹窗 */
.gross-dialog-toolbar {
  padding: 0 4px 8px;
}

.gross-dialog-toolbar .el-form-item {
  margin-bottom: 0;
}

.range-sep {
  margin: 0 10px;
  color: #909399;
  font-size: 13px;
}

.gross-chart-body {
  min-height: 380px;
  position: relative;
}

.gross-chart-wrap {
  width: 100%;
  height: 380px;
}

.chart-empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  background: #fafafa;
  border-radius: 6px;
}

.chart-empty i {
  font-size: 48px;
  margin-bottom: 12px;
}

.chart-empty p {
  margin: 0;
  font-size: 14px;
  color: #909399;
}
</style>


// WEBPACK FOOTER //
// src/views/sales/index.vue